import React from 'react';
import { Field } from 'react-final-form';
import { createUseStyles } from 'react-jss';
import PropTypes from 'prop-types';
import Select from '../../Fields/Select/Select';
import ButtonInput from '../../Fields/ButtonInput/ButtonInput';
import LabelWithContent from '../../Fields/LabelWithContent/LabelWithContent';
import Popover from '../../Popover/Popover';
import RegularPopover from './Popovers/Regular';
import MotoImage from '../../../images/moto.png';
import Input from '../../Fields/Input/Input';
import Label from '../../Fields/Label/Label';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';

const FieldLabel = ({ label, title, description, }) => {
  return (
    <LabelWithContent
      label={label}
      content={
        <Popover
          wrapperStyle={{ marginLeft: 5, }}
          content={
            <RegularPopover
              title={title}
              description={description}
            />
          }
        />
      }
    />
  );
};

const AdNewFormCondition = (props) => {
  const { currentDriveType, t, tReady, } = props;
  const styles = useStyles();
  if (!tReady) {
    return null
  }
  return (
    <div className={styles.container}>
      <div className={styles.leftColumn} name="brand_id">
        <FieldLabel
          label={t('brand')}
          title={t('brand')}
          description={t('brand')}
        />
        <Field
          name="brand_id"
          options={t('brands', { returnObjects: true, })}
          component={Select}
        />
      </div>

      <div className={styles.rightColumn} name="model">
        <FieldLabel
          label={t('model')}
          title={t('model')}
          description={t('brand')}
        />
        <Field
          name="model"
          component={Input}
        />
      </div>
      <div className={styles.leftColumn} name="vehicle_type">
        <FieldLabel
          label={t('vehicle_type')}
          title={t('vehicle_type')}
          description={t('brand')}
        />
        <Field
          name="vehicle_type"
          options={t('vehicle_types', { returnObjects: true, })}
          component={Select}
        />
      </div>
      <div className={styles.rightColumn} name="cubic_capacity">
        <FieldLabel
          label={t('cubic_capacity')}
          title={t('cubic_capacity')}
          description={t('brand')}
        />
        <Field
          name="cubic_capacity"
          type="number"
          component={Input}
        />
      </div>
      <div className={styles.motoImageWrapper}>
        <img src={MotoImage} alt="motorcycle" />
      </div>
      <div className={styles.leftColumn} name="drive_type">
        <FieldLabel
          label={t('drive_type')}
          title={t('drive_type')}
          description={t('default_condition_hint')}
        />
        <div className={styles.buttonInputsWrapper}>
          {
            Object.entries(t('drive_type_options', { returnObjects: true, })).map((driveType, index) => (
              <ButtonInput
                key={driveType[0]}
                groupName="drive_type"
                value={driveType[0]}
                label={driveType[1]}
                active={currentDriveType === driveType[0]}
                wrapperStyle={{ width: '100%', marginLeft: (index === 0 ? 0 : 5), }}
                labelStyle={{ padding: '20px 16px 19px 16px', textAlign: 'center', }}
              />
            ))
          }
        </div>
      </div>

      <div className={styles.rightColumn} name="power">
        <FieldLabel
          label={t('power')}
          title={t('power')}
          description={t('brand')}
        />
        <Field
          name="power"
          type="number"
          component={Input}
        />
      </div>
      <div className={styles.rightColumn} name="gear_box">
        <Label
          label={t('gear_box')}
        />
        <Field
          name="gear_box"
          options={t('gear_box_options', { returnObjects: true, })}
          component={Select}
          isSearchable
        />
      </div>
      <div className={styles.leftColumn} name="color">
        <Label
          label={t('color')}
        />
        <Field
          name="color"
          options={t('colors', { returnObjects: true, })}
          component={Select}
          isSearchable
        />
      </div>
    </div>
  );
};

const useStyles = createUseStyles({
  row: {
    marginBottom: 15,
  },
  leftColumn: {
    width: 'clamp(350px, 48%, 100vh)',
  },
  rightColumn: {
    width: 'clamp(350px, 48%, 100vh)',
  },
  buttonInputsWrapper: {
    display: 'flex',
  },
  motoImageWrapper: {
    textAlign: 'center',
    width: '100%',
  },
  container: {
    padding: '0px 15px',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  '@media screen and (max-width: 991px)': {
    leftColumn: {
      padding: 0,
    },
    rightColumn: {
      paddingTop: 15,
      paddingLeft: 0,
      paddingRight: 0,
    },
    motoImageWrapper: {
      width: '-webkit-fill-available',
      '& img': {
        width: '200px',
      },
    },
  },
});

FieldLabel.propTypes = {
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

AdNewFormCondition.propTypes = {
  t: PropTypes.func.isRequired,
  currentDriveType: PropTypes.string,
  tReady: PropTypes.bool.isRequired,
};

AdNewFormCondition.defaultProps = {
  currentDriveType: '',
};

export default withScopedTranslations('ad_vehicle_description')(AdNewFormCondition);
